(()=>{
'use strict';
const order=['XXXS','XXS','XS','S','M','L','XL','XXL','3XL','4XL','4XL+','5XL','6XL','ONE SIZE'];
const clean=x=>String(x??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
function alpha(x){const s=clean(x).toUpperCase().replace(/\s*\/\s*/g,'/').replace(/\b2XL\b/g,'XXL').replace(/XXXL/g,'3XL');return s.split('/').every(y=>order.includes(y))&&s.split('/').length<=2?s:'';}
function waist(g,w){
 if(!Number.isInteger(w)||w<20||w>60)return '';
 const ranges=g==='Femei'?[[23,'XXS'],[25,'XS'],[26,'S'],[27,'S/M'],[29,'M'],[30,'M/L'],[32,'L'],[33,'L/XL'],[35,'XL'],[38,'XL/XXL'],[40,'XXL'],[44,'3XL'],[45,'3XL/4XL'],[47,'4XL'],[60,'4XL+']]:g==='Barbati'?[[28,'XS'],[29,'XS/S'],[31,'S'],[32,'S/M'],[33,'M'],[35,'M/L'],[36,'L'],[37,'L/XL'],[38,'XL'],[39,'XL/XXL'],[40,'XXL'],[41,'XXL/3XL'],[44,'3XL'],[45,'3XL/4XL'],[47,'4XL'],[60,'4XL+']]:[];
 return ranges.find(([limit])=>w<=limit)?.[1]||'';
}
function analyze(p){
 const title=clean(p.title),type=clean(p.productType).toLowerCase();
 const gender=type==='femei'?'Femei':type==='barbati'?'Barbati':'';
 const titleG=title.match(/\b(Femei|Barbati)\s*$/i)?.[1]?.toLowerCase();
 const issues=[];
 if(!gender)issues.push('Gen lipsa sau neclar');
 if(titleG&&titleG!==type)issues.push('Gen diferit intre titlu si tipul produsului');
 if(p.variants.pageInfo.hasNextPage)issues.push('Lista variantelor incompleta');
 const sizes=p.variants.nodes.filter(v=>v.inventoryQuantity>0).map(v=>{
  const opts=v.selectedOptions.filter(o=>/^(size|marime|marimea)$/i.test(clean(o.name)));
  return opts.length===1?opts[0].value:'';
 });
 const unique=[...new Set(sizes)];
 if(unique.length!==1||!unique[0])issues.push('Marimi multiple sau lipsa: verificare pe variante');
 const raw=unique.length===1?unique[0]:unique.join(' / '),a=alpha(raw);
 const wm=clean(raw).toUpperCase().match(/^W\s*(\d{2})(?:\s*\/\s*L\s*\d{2})?$/);
 const titleWaists=[...title.matchAll(/\bW\s*(\d{2})\b/gi)].map(m=>Number(m[1]));
 if(wm&&titleWaists.some(w=>w!==Number(wm[1])))issues.push('W diferit intre titlu si varianta');

 const base=title.replace(/\s*[-–—]\s*(Femei|Barbati|Unisex)\s*$/i,'');
 const named=base.match(/\b(?:marimea|marime|mairmea|size)\s+(.+)$/i)?.[1];
 let segment=named??base.split(/\s+[-–—]\s+/).pop();
 segment=segment.trim().replace(/^W\s*\d{2}(?:\s*\/\s*L\s*\d{2})?\s*/i,'');
 const alphaPattern='(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL\\+?|ONE SIZE)(?:\\s*\\/\\s*(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL\\+?))?';
 const token=segment.match(new RegExp('^'+alphaPattern+'(?=$|\\s|[,;])','i'));
 const nearWaist=base.match(new RegExp('(?:^|\\s)'+alphaPattern+'(?=\\s+W\\s*\\d{2}\\b)','i'));
 const ta=alpha((token?.[0]||nearWaist?.[0]||'').trim());
 let normalized='',source='';
 if(a){normalized=a;source='Marime internationala existenta';if(ta&&ta!==a){if(ta.includes('/')&&ta.split('/').includes(a)){normalized=ta;source='Interval international existent compatibil cu varianta';}else issues.push('Marime internationala diferita intre titlu si varianta');}}
 else if(wm){

  if(!ta&&(!/^blugi\b/i.test(title)||/^blugi\s+scurti\b/i.test(title)))issues.push('W in afara categoriei Blugi: necesita regula verificata');
  if(ta){normalized=ta;source='Echivalent international deja in titlu';}
  else {normalized=waist(gender,Number(wm[1]));source='Echivalare orientativa W dupa gen';}
  if(!normalized)issues.push('W fara echivalent sigur');
 }else issues.push('Marime nerecunoscuta; nu se converteste automat');
 if(p.normalizedSize)issues.push('Camp normalizat existent: protejat de suprascriere');
 const values=issues.length?[]:normalized.split('/').filter(Boolean);
 return {id:p.id,handle:p.handle,title:p.title,gender,raw,normalized,values,source,issues,status:issues.length?'review':'ready',isW:!!wm,url:p.onlineStoreUrl||`https://intreumerase.ro/products/${p.handle}`,image:p.featuredImage?.url,updatedAt:p.updatedAt,online:p.status==='ACTIVE'&&!!p.onlineStoreUrl&&p.variants.nodes.some(v=>v.inventoryQuantity>0),existingTitleAlpha:ta};
}

function resolve(data){
 if(!Array.isArray(data.options)||!Array.isArray(data.selected))return [];
 const selectedOptions=data.selected.map((value,i)=>({name:data.options[i],value}));
 const result=analyze({title:data.title,productType:data.productType,variants:{pageInfo:{hasNextPage:false},nodes:[{inventoryQuantity:1,selectedOptions}]}});
 return result.values;
}
function upgrade(scope){
 for(const box of scope.querySelectorAll('[data-iu-sold-size]')){
  if(box.dataset.sizeReady)continue;
  box.dataset.sizeReady='true';
  const link=box.querySelector('[data-iu-sold-alternatives]');
  if(!link)continue;
  try{
   const sizes=resolve({title:box.dataset.title,productType:box.dataset.productType,options:JSON.parse(box.dataset.options),selected:JSON.parse(box.dataset.selected)});if(!sizes.length)continue;
   const url=new URL(link.href);if(url.origin!==location.origin)continue;
   url.searchParams.delete('iu_size');for(const size of sizes)url.searchParams.append('iu_size',size);
   link.href=url.href;
   link.textContent=link.dataset.sizeLabel.replace('[link]',link.textContent).replace('[size]',sizes.join('/'));
  }catch{}
 }
}
if(typeof document==='undefined'){globalThis.IUSoldSizeResolve=resolve;return;}
if(window.IUSoldSizeReady)return;window.IUSoldSizeReady=true;
const start=()=>{
 upgrade(document);
 new MutationObserver(records=>{
  for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1){
   if(node.matches('[data-iu-sold-size]'))upgrade(node.parentElement);else if(node.querySelector('[data-iu-sold-size]'))upgrade(node);
  }
 }).observe(document.body,{childList:true,subtree:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
